module.exports = __webpack_public_path__ + "54168e77e51729a6968a9309d6c04c05.jpg";